import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import getTranslation from '../../TranslationUtility/TranslationUtility';
import { useSelector } from 'react-redux';

const CustomBackHeader = ({ title = "", backArrowIconComponent = null, rightComponent, isTransperent = false, customClass = "", isSticky = false, backBtnRef }) => {
    const navigate = useNavigate();
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const clientData = clientMasterData?.clientMasterData || [];
    const emptySpaceHolder = <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>;

    const handleResize = () => {
        setIsMobileView(window.innerWidth <= 769);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>{<header className={`${isSticky && "fixed z-50"} ${isTransperent ? "bg-transparent absolute z-50" : "bg-white border-b-2 border-grey"} w-full p-4 flex items-center justify-content-between ${customClass || ""}`}>
            {clientData[0]?.isBackButton && isMobileView ? <div className="flex items-center ">
                <Link className="flex items-center" onClick={() => {
                    if (backBtnRef) {
                        backBtnRef.current = true;
                    }
                    navigate(-1)
                }}>
                    {backArrowIconComponent ? backArrowIconComponent : <button className="text-xl menu-head" aria-label="Go back">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            className="w-8 h-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M10 19l-7-7 7-7"
                            />
                            <line
                                x1="3"
                                y1="12"
                                x2="21"
                                y2="12"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                        </svg>
                    </button>}
                </Link>
            </div> : emptySpaceHolder}
            <h1 className="font-semibold line-hi banner-carousel">
                {title || ""}
            </h1>
            {rightComponent ? rightComponent : emptySpaceHolder}
        </header>}
        </>
    )
}

export default CustomBackHeader